import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  generateKey,
} from "../utils/setting";
const auditBalance = {
  state: {
    total: 0,
    list: [],
    count: 0,
    ipAddress: "",
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    getHistory(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/auditBalances/getHistory";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({
              list: result.data.list,
              total: result.data.total,
              count: result.data.count,
            });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
  }),
};

export default auditBalance;
